import { HierarchyManager } from "../../components/HierarchyManager";
import { regionConfig } from "./regionConfig";

function RegionsPage() {
  return <HierarchyManager config={regionConfig} />;
}

export default RegionsPage;
